import { media } from 'src/assets/_responsive-mixin';
import styled from 'styled-components';

export const DescriptionList = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  margin-bottom: 1rem;
  position: relative;

  li {
    padding: 0 1.5rem;

    &:first-of-type {
      padding-left: 0;
    }

    &:not(:last-of-type) {
      display: flex;
      flex-direction: column;
      border-right: 1px solid var(--primary-color20);
    }

    h3,
    h4,
    h5 {
      color: var(--primary-color60);
    }
  }

  ${media.small`
    flex-direction: column;

    &&& li {
      padding: 0.5rem 0;
      border-right: 0;
      border-bottom: 1px solid var(--primary-color20);
    }
  `}
`;
